import { Component, Input, booleanAttribute, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Button } from '../button/button.component';

@Component({
  selector: 'procure-refresh-button',
  templateUrl: './refresh-button.component.html',
  imports: [MatIcon, Button],
})
export class RefreshButton {
  @Input({ transform: booleanAttribute }) disabled: boolean | null = false;
  @Input({ transform: booleanAttribute }) isLoading: boolean | null = false;

  readonly refresh = output<void>();
}
